module.exports = __webpack_public_path__ + "img/Malawi.56575bae.svg";